<div class="">
	<div class="upload-action-box p-4">
		<div *ngIf="docTypes && docTypes.length;">
			<p><b>{{btnName}}:</b></p>
			<p *ngIf="artifact?.description" [innerHTML]="artifact.description"></p>
			<div class="row">
				<div class="d-flex flex-wrap">
					<div class="me-3" *ngIf="docTypes.length>1">
						<mat-form-field class="mat-form-transparent">
							<mat-label>Select Doc Type</mat-label>
							<mat-select [(ngModel)]="selectedDocTypes.documentType" [disabled]="isReadonly()">
								<mat-option *ngFor="let docType of docTypes;let i = index;"
									[value]="docType">{{docType.displayName}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="me-3" *ngIf="selectedDocTypes.documentType.subTypes.length>1">
						<mat-form-field class="mat-form-transparent">
							<mat-label>Select Sub Doc Type</mat-label>
							<mat-select [(ngModel)]="selectedDocTypes.documentSubType" [disabled]="isReadonly()">
								<mat-option
									*ngFor="let subDocType of selectedDocTypes.documentType.subTypes;let i = index;"
									[value]="subDocType">{{subDocType.displayName}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
		<div style="position: relative;">
			<div class="dropzone rounded-3" ng2FileDrop [uploader]="uploader" (onFileDrop)="onFileSelected();">
				<div class="text-wrapper">
					<div class="centered">
						<div>Drag and drop files here or </div>
						<br>
						<input type="file" [id]="'file'+compId" ng2FileSelect [uploader]="uploader" (change)="onFileSelected();">
						<label [for]="'file'+compId"><span class="textLink">Browse</span></label>
					</div>
				</div>
			</div>
			<div class="dropzone" style="position: absolute;top: 0px; opacity: 0.5;" *ngIf="!validateDocType() || isReadonly()" ng2FileDrop [uploader]="uploader" 
				(click)="validateUpload()" 
				(onFileDrop)="onFileSelected();"
			></div>
		</div>

		<hr>
		<span>
			Supported file formats are *.{{extension.join(", *.")}}. 
			Maximum file size limit is 10 MB per file. Password protected or encrypted file cannot be uploaded. 
		</span><br>
		<span style="color: #EA1A47;">Maximum upload limit is {{appConfig.maxFileCount}} {{appConfig.maxFileCount==1?"file":"file(s)"}}.</span>
		<!-- {{uploadSummary|json}} -->
		<div class="row my-2" *ngFor="let item of uploadSummary">
			<div class="col-sm-12">
				<div class="d-flex">
					<span *ngIf="checkViewerRoles(item)" (click)="viewDocument(item)" class="cursor-pointer"><strong>{{ item.name }}</strong></span>
					<span *ngIf="!checkViewerRoles(item)"><strong>{{ item.name }}</strong></span>
					<div class="ms-2" *ngIf="!isReadonly()">
						<mat-icon (click)="removeuploaded(item)" class="cursor-pointer">delete</mat-icon>
					</div>
				</div>
			</div>
			<div class="col-sm-12">
				<div class="d-flex">
					<div class="progress w-100 mt-1">
						<div class="progress-bar" [ngClass]="{'bg-success' : item.status == 'uploaded'}" role="progressbar" [ngStyle]="{ 'width': getProgressValue(item) + '%' }">{{getProgressValue(item)}}%</div>
					</div>
				</div>
			</div>
		</div>
		<div class="upload-failed-banner" *ngIf="hasFailedUploads()">
			<mat-icon>error_outline</mat-icon>
			<span>
				<strong>This section is not complete.</strong>
				The following {{ failedUploads.length == 1 ? 'file' : 'files' }} did not upload:
				<span class="upload-failed-text">{{ failedUploadNames() }}</span>.
				Please upload {{ failedUploads.length == 1 ? 'it' : 'them' }} again.
			</span>
		</div>
	</div>
</div>